export default "__VITE_ASSET__Fk1e7QfM__"